import { Box, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function StarburstConnectForm({ onSubmit, guideMode }) {
  const formInitialValues = {
    client_id: "",
    client_secret: "",
    account_url: "",
  };

  const formCheckoutSchema = yup.object().shape({
    client_id: yup.string().required("Client ID is required"),
    client_secret: yup.string().required("Secret Key is required"),
    account_url: yup
      .string()
      .required("Account URL is required")
      .url("Must be a valid URL")
      .matches(
        /\.galaxy\.starburst\.io\/?$/,
        "Account URL must be a valid Starburst Galaxy domain"
      ),
  });

  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="client_id"
                label="Client ID"
                value={values.client_id}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.client_id && !!errors.client_id}
                helperText={
                  touched.client_id && errors.client_id
                    ? String(errors.client_id)
                    : ""
                }
                disabled={guideMode}
                placeholder="Enter your token Client ID"
              />
              <TextField
                fullWidth
                variant="filled"
                name="client_secret"
                label="Secret Key"
                value={values.client_secret}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.client_secret && !!errors.client_secret}
                helperText={
                  touched.client_secret && errors.client_secret
                    ? String(errors.client_secret)
                    : ""
                }
                disabled={guideMode}
                placeholder="Enter your token Secret Key"
              />
              <TextField
                fullWidth
                variant="filled"
                name="account_url"
                label="Account URL"
                value={values.account_url}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.account_url && !!errors.account_url}
                helperText={
                  (touched.account_url && errors.account_url
                    ? String(errors.account_url)
                    : "") || "e.g., https://your-account.galaxy.starburst.io"
                }
                disabled={guideMode}
                placeholder="https://your-account.galaxy.starburst.io"
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
